import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import axios from "axios";

import { LoadingIcon } from '../Common/Loading_Icon';
import EUBookingCard from './EUSidebarBookingCard';
import EmptyState from '../Common/EmptyState';
import { constants } from '../../Helpers/Constants';
import EUSidebarMediaCard from './EUSidebarMediaCard';
import ModalRoutes from '../Pages/ModalRoutes';
import EUBookingPullout from './EUBookingPullout';
import { setSidebar } from '../../Actions/endUserActions';

import { checkCredentials } from '../../Helpers/checkCredentials.js';
import { UserDefault, CalendarDefault, MediaDefault, ProfileAddImageSidebar } from '../Common/Buttons/Icons';
import { Trans } from 'react-i18next';
import moment from 'moment';


class EUSidebar extends Component {
    constructor(props) {
        super(props);

        this.goSettings = this.goSettings.bind(this);

        this.state = {
            sidebar_data: null
        };
    }

    componentDidMount() {
        var self = this;

        axios.get('/ajax/eu-home/sidebar')
        .then(function(response) {
            checkCredentials(response);
            if (! ("status" in response?.data)) {
                self.props.dispatch(setSidebar(response))
            }
        })
    }

    toggleDropdown(id) {
        const element = document.getElementById(id);
        if (!element) return;

        if(element.classList.contains('is-open')) {
            element.classList.remove('is-open');
        } else {
            $('.dropdown-pane').removeClass('is-open');
            element.classList.add('is-open');
        }
    }

    goSettings() {
        this.props.history.push("/settings");
    }

    render() {
        return (
            <div className="eu-sidebar" id = "eu-sidebar">
                <div className="eu-sidebar--mobileheader">
                    <button className="close-button float-right" aria-label="Close alert" type="button" onClick={()=>this.toggleDropdown('sideMenu')}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                {
                    this.props.endUser.sidebar_data ?
                        <div className="eu-sidebar-wrapper">
                            {/* Profile Section */}
                            <div className="eu-sidebar-section eu-sidebar-profile">
                                <div className = "eu-sidebar-section-title mb-24">
                                    {UserDefault("fill-grey")} <h1><Trans>Profile</Trans></h1>
                                    <Link to={"/settings"}><Trans>Edit</Trans></Link>
                                </div>
                                <div className="eu-sidebar-profile-info">
                                    {
                                        this.props.userSession.user.photo && this.props.userSession.user.photo !== "" ?
                                            <div className="eu-sidebar-profile-img">
                                                <img src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + this.props.userSession.user.photo} className="circled_image"/>
                                            </div>
                                        :
                                            <div className="eu-sidebar-profile-img" onClick={this.goSettings} style={{cursor: "pointer"}}>
                                                <div className="eu-sidebar-profile-img-name">
                                                    {
                                                        this.props.userSession.user && this.props.userSession.user.first_name && this.props.userSession.user.last_name ? 
                                                            <>{this.props.userSession.user.first_name.charAt(0) + this.props.userSession.user.last_name.charAt(0)}</>
                                                        :
                                                            null
                                                    }
                                                </div>
                                                <div className="user_image_add_icon">
                                                    {ProfileAddImageSidebar()}
                                                </div>
                                            </div>
                                    }
                                    <div className="eu-sidebar-profile-name">
                                        <div>{this.props.userSession.user.full_name}</div>
                                    </div>
                                </div>
                                <div className="eu-sidebar-profile-stats">
                                    <div className="eu-sidebar-profile-stats-tile">
                                        <h1>{this.props.endUser.sidebar_data.num_bookings}</h1>
                                        <p><Trans>Completed Bookings</Trans></p>
                                    </div>
                                    {this.props.userSession.user.user_role === constants.user_role.media_influencer ?
                                        <div className="eu-sidebar-profile-stats-tile">
                                            <h1>{this.props.endUser.sidebar_data.num_media}</h1>
                                           <p><Trans>Completed Submissions</Trans></p>
                                        </div>
                                    : null}
                                    <div className="eu-sidebar-profile-stats-tile">
                                        <h1 style={{fontSize: 12}}>{moment(this.props.endUser.sidebar_data.member_since).format('MMM D, YYYY')}</h1>
                                        <p><Trans>Member Since</Trans></p>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="eu-sidebar-divider"></div>

                            {/* Booking Section */}
                            <div className="eu-sidebar-section eu-sidebar-booking">
                                <div className = "eu-sidebar-section-title mb-24">
                                    {CalendarDefault("fill-grey")} <h1><Trans>Bookings</Trans></h1>
                                    <Link to="/bookings/current"><Trans>See All</Trans></Link>
                                </div>

                                {/*Current Booking*/}
                                <div className="eu-sidebar-booking-type">
                                    <Trans>Current</Trans>
                                </div>
                                {
                                    this.props.endUser.sidebar_data.current_booking ? 
                                        <EUBookingCard booking={this.props.endUser.sidebar_data.current_booking} history={this.props.history} match={this.props.match} location={this.props.location}/>
                                    :
                                        <div className = "emptystate-wrapper">
                                            <h2><Trans>No Current Bookings</Trans></h2>
                                            <img style={{width: "50px"}} src = "images/emptystate-icons/Calendar_Inactive.svg"/>
                                        </div>
                                }
                                

                                {/*Next Booking*/}
                                <div className="eu-sidebar-booking-type">
                                    <Trans>Next</Trans>
                                </div>
                                {
                                    this.props.endUser.sidebar_data.upcoming_booking ? 
                                        <EUBookingCard booking={this.props.endUser.sidebar_data.upcoming_booking} history={this.props.history} match={this.props.match} location={this.props.location}/>
                                    :
                                        <div className = "emptystate-wrapper">
                                            <h2><Trans>No Upcoming Bookings</Trans></h2>
                                            <img style={{width: "50px"}} src = "images/emptystate-icons/Calendar_Inactive.svg"/>
                                        </div>
                                }
                            </div>
                            <div className="eu-sidebar-divider"></div>

                            {/* Media Section */}
                            {
                                this.props.userSession.user.user_role === constants.user_role.media_influencer ?
                                    <div className="eu-sidebar-section eu-sidebar-media">
                                            <div className = "eu-sidebar-section-title mb-24">
                                                {MediaDefault("fill-grey")} <h1><Trans>Media</Trans></h1>
                                                <Link to="/eu-media"><Trans>See All</Trans></Link>
                                            </div>
                                        {
                                            this.props.endUser.sidebar_data.outstanding_bookings.length > 0 ?
                                                this.props.endUser.sidebar_data.outstanding_bookings.map((booking, i) => {
                                                    return(
                                                        <EUSidebarMediaCard key={i} booking={booking} history={this.props.history} match={this.props.match} location={this.props.location} first={i === 0 ? true : false}/>
                                                    )
                                                })
                                            :
                                                <div className = "emptystate-wrapper">
                                                    <h2><Trans>No Outstanding Media</Trans></h2>
                                                    <img style={{width: "50px"}} src = "images/emptystate-icons/Media_Inactive.svg"/>
                                                </div>
                                        }
                                    </div>
                                :
                                    null
                            }
                        </div>
                    :
                        <div className="eu-sidebar-wrapper"/>
                }
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
});

export default connect(mapStateToProps)(EUSidebar);